import Bootstrap from "./features/bootstrap/Bootstrap";
import Login from "./features/signIn/Login";
import PasswordScaduta from "./features/signIn/PasswordScaduta";
import Loading from "./components/dataTable/Loading";
import SessioneInScadenza from "./features/SessioneInScadenza";
import SessioneScaduta from "./features/SessioneScaduta";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Layout from "./pages/Layout";
import ProtectedRoute from "./core/ProtectedRoute";
import Welcome from "./pages/Welcome";
import SpoolPage from "./pages/Spool";
import AziendaGeneralitaPage from "./pages/azienda/Azienda.generalita.page";
import Azienda from "./pages/Azienda";
import TabelleRetributivePage from "./pages/azienda/tabelle/ElementiRML.page";
import QualifichePage from "./pages/azienda/tabelle/Qualifiche.page";
import LavoratoriGeneralitaPage from "./pages/lavoratori/generalita/Lavoratori.generalita.page";
import LavoratoriRetribPage from "./pages/lavoratori/Lavoratori.retrib.page";
import Frame from "./pages/presenze/dashboardWF/frame";
import RetribPage from "./pages/PVA/pva.retribuzione.page";
import ImportPVAPage from "./pages/PVA/pva.import.page";
import Dominio from "./pages/Dominio";
import ElementiRMLPage from "./pages/sistema/elementiRML/ElementiRML.page";
import CCNLPage from "./pages/sistema/tabelleMinisteriali/CCNL.page";
import NotFound from "./features/notFound/NotFound";
import React, {useState} from "react";
import {AppHRProps} from "./App";
import PrimoAccesso from "./features/signIn/PrimoAccesso";
import LavoratoriDocumentiPage from "./pages/lavoratori/Lavoratori.documenti.page";
import {QueryClientProvider} from "@tanstack/react-query";
import {queryClient} from "@utilities/config.ReactQuery";
import WaitingForActivation from "./features/signIn/WaitingForActivation";
import AziendaNavContainer from "./features/azienda/AziendaNavContainer";
import {Workflow} from "./pages/presenze/workflow/workflow";
import UserProfilePage from "./pages/accesso/UserProfile";
import {Pianificazione} from "./pages/presenze/pianificazione/pianificazione";
import {Test} from "./pages/test";
import Accesso from "./pages/Accesso";
import {MonitorWorkflow} from "./pages/presenze/monitorWF/monitorWF";
import {GestionePlusPage} from "./pages/presenze/GestionePLUS/GestionePlus.page";
import {Organigrammi} from "./pages/organigrammi/Organigrammi";

const AppHR: React.FC<AppHRProps> = ({isBoot, isRunning, isTrust, appState, minutiDiInattivita}) => {
    const sfondo = {
        //"background": `url('${process.env.PUBLIC_URL}/images/File_001.jpeg')`,
        "background": `url('${process.env.PUBLIC_URL}/images/banner-img.jpg')`,
        "backgroundSize": "cover",
        "backgroundRepeat": "no-repeat",
        "backgroundPosition": "center",
    }
    const [isBusy, setIsBusy] = useState<boolean>(false);
    return (
        <>
            {isBoot && <Bootstrap/>}
            {!isBoot && <>
                {!isRunning &&
                    <div className="h-screen" style={sfondo}>
                        {appState === 'READY' && <Login/>}
                        {appState === 'PWD_EXPIRED' && <PasswordScaduta/>}
                        {appState === 'FIRST_LOGIN' && <PrimoAccesso/>}
                        {appState === 'WAITINGFORACTIVATION' && <WaitingForActivation/>}
                    </div>
                }
                {isRunning &&
                    <Loading loading={appState === 'ISEXPIRING' || appState === 'EXPIRED'}
                             spinner={appState === 'ISEXPIRING' ? <SessioneInScadenza/> : <SessioneScaduta/>}>

                        <BrowserRouter basename="/HR">
                            <Routes>
                                {/*// vedi https://reactrouter.com/en/main/components/outlet*/}
                                <Route path="/" element={<Layout minuti={minutiDiInattivita}/>}>

                                    <Route element={<ProtectedRoute isTrust={isTrust}/>}>
                                        <Route index path="welcome" element={
                                            <QueryClientProvider client={queryClient}>
                                                <Welcome/>
                                            </QueryClientProvider>
                                        }/>
                                        <Route index path="yup" element={<Accesso/>}/>
                                        <Route index path="test" element={<Test/>}/>
                                        <Route index path="spool" element={<SpoolPage/>}/>

                                        <Route path="accesso">
                                            <Route path="userProfile" element={<UserProfilePage/>}/>
                                        </Route>

                                        <Route path="azienda">
                                            <Route path="generalitaAz" element={<AziendaGeneralitaPage/>}/>
                                            <Route path="ul" element={<Azienda/>}/>
                                            <Route path="organigrammi" element={<Organigrammi/>}/>
                                            <Route path="tabelle">
                                                <Route path="tabelle-retributive" element={<TabelleRetributivePage/>}/>
                                                <Route path="qualifiche" element={<QualifichePage/>}/>
                                                <Route path="retribuzione" element={<QualifichePage/>}/>
                                            </Route>
                                        </Route>

                                        <Route path="lavoratori">
                                            <Route path="generalita" element={<LavoratoriGeneralitaPage/>}/>
                                            <Route path="retribuzione" element={<LavoratoriRetribPage/>}/>
                                            <Route path="documenti" element={
                                                <QueryClientProvider client={queryClient}>
                                                    <LavoratoriDocumentiPage/>
                                                </QueryClientProvider>}/>
                                        </Route>

                                        <Route path="presenze">
                                            <Route path="gestionePlus" element={
                                                <QueryClientProvider client={queryClient}>
                                                    <AziendaNavContainer>
                                                        <GestionePlusPage/>
                                                    </AziendaNavContainer>
                                                </QueryClientProvider>
                                            }/>
                                            <Route path="workflow-employee" element={
                                                <QueryClientProvider client={queryClient}>
                                                    <AziendaNavContainer>
                                                        <Workflow/>
                                                    </AziendaNavContainer>
                                                </QueryClientProvider>
                                            }/>
                                            <Route path="monitorWorkflow" element={
                                                <QueryClientProvider client={queryClient}>
                                                    {/*<ReactQueryDevtools initialIsOpen={false}/>*/}
                                                    <AziendaNavContainer>
                                                        <MonitorWorkflow/>
                                                    </AziendaNavContainer>
                                                </QueryClientProvider>
                                            }/>
                                            <Route path="dashboard-wf" element={<Frame/>}/>
                                            <Route path="pianificazione" element={
                                                <QueryClientProvider client={queryClient}>
                                                    <AziendaNavContainer onNavSetIsBusy={true}>
                                                        <Pianificazione/>
                                                    </AziendaNavContainer>
                                                </QueryClientProvider>
                                            }/>
                                        </Route>

                                        <Route path="PVA">
                                            <Route path="retribuzione" element={<RetribPage/>}/>
                                            <Route path="import" element={<ImportPVAPage/>}/>
                                        </Route>

                                        <Route path="dominio">
                                            <Route path="dominio" element={<Dominio/>}/>
                                        </Route>

                                        <Route path="systemTable">
                                            <Route path="elementiRML" element={<ElementiRMLPage/>}/>
                                            <Route path="tabelle-ministeriali">
                                                <Route path="CCNL" element={<CCNLPage/>}/>
                                            </Route>
                                        </Route>
                                    </Route>

                                    {/*<Route path="/team" element={<Team/>}/>*/}
                                    <Route path="*" element={<NotFound/>}/>
                                </Route>
                            </Routes>
                        </BrowserRouter>
                    </Loading>
                }
            </>
            }
        </>
    );
}
export default AppHR;